import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, } from "@mui/material";
import { CaretDown } from "@phosphor-icons/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { convertToNLEuroFormat } from "../../../application/common/utils/helper";
const ContractObjectPriceAccordion = ({ amount }) => {
    const { t: translate } = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const handleAccordionChange = () => {
        setExpanded(!expanded);
    };
    return (_jsx(Box, { sx: {
            display: "flex",
            position: "relative",
            alignItems: "center",
            justifyContent: "center",
        }, children: _jsx(Box, { sx: {
                width: "100%",
            }, children: _jsxs(Accordion, { expanded: expanded, onChange: handleAccordionChange, sx: {
                    bottom: "-1px",
                    borderBottomLeftRadius: "0 !important",
                    borderBottomRightRadius: "0 !important",
                }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(CaretDown, { size: 24 }), "aria-controls": "panel1-content", id: "panel1-header", children: _jsxs(Grid, { container: true, size: 12, sx: {
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: { sm: "0px 12px 8px 12px", md: "0px px 16px 24px" }
                            }, children: [_jsx(Grid, { children: _jsxs(Typography, { className: "accordianheading", children: [translate("Amount"), " (excl. BTW)"] }) }), _jsx(Grid, { children: !expanded && (_jsx(Box, { className: "pricecontainer", children: _jsx(Typography, { className: "pricetext", children: amount > 0
                                                ? `${convertToNLEuroFormat(parseFloat((Math.round(amount * 100) / 100).toFixed(2)))}`
                                                : convertToNLEuroFormat(parseFloat((Math.round(amount * 100) / 100).toFixed(2))) }) })) })] }) }), _jsx(AccordionDetails, { children: _jsx(Grid, { container: true, children: _jsxs(Grid, { container: true, size: 12, sx: {
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: { sx: "0px 12px 8px 12px", sm: "0px 12px 8px 12px", md: "0px 0px 16px 16px" }
                                }, children: [_jsx(Grid, { children: _jsx(Typography, { children: translate("Total") }) }), _jsx(Grid, { children: _jsx(Box, { className: "pricecontainer", children: _jsx(Typography, { className: "pricetext", children: amount > 0
                                                    ? `${convertToNLEuroFormat(parseFloat((Math.round(amount * 100) / 100).toFixed(2)))}`
                                                    : convertToNLEuroFormat(parseFloat((Math.round(amount * 100) / 100).toFixed(2))) }) }) })] }) }) })] }) }) }));
};
export default ContractObjectPriceAccordion;
